import { FilterParam as T } from "../../../../../types.js";
const E = [T.CURRENCIES, T.CATEGORIES, T.STATUSES], A = Object.freeze(
  Object.fromEntries(E.map((e) => [e, ""]))
), r = [
  "ATM",
  "Capital",
  "Chargeback",
  "Correction",
  "Fee",
  "Payment",
  "Refund",
  "Transfer",
  "Other"
], I = ["Booked", "Pending", "Reversed"];
export {
  A as DEFAULT_TRANSACTIONS_OVERVIEW_MULTI_SELECTION_FILTER_PARAMS,
  E as TRANSACTIONS_OVERVIEW_MULTI_SELECTION_FILTERS,
  r as TRANSACTION_CATEGORIES,
  I as TRANSACTION_STATUSES
};
